module.exports = "https://99designs-start-assets.imgix.net/js/1463d912953362a58735f1b48d3515b5.png";